<template>
  <span :class="{ 'entity-decoration': decorate }" :style="decorationStyle">
    <slot>
    </slot>
    <span v-if="hasOrcid">
      <a target="_blank" :href="`https://orcid.org/${resourceData.orcid}`">
		<img width="16" height="16" src="../assets/orcid_logo.svg">
      </a>
	</span>
  </span>
</template>

<script>
export default {
  name: 'fob-entity-decorator',
  props: {
    isPublic: {
      type: Boolean,
      default: false
    },
    resourceData: {
      type: [String, Boolean, Number, Object, Array, Date],
      default: null
    }
  },
  computed: {
    hasOrcid () {
      if (!this.resourceData._entityName) { return false }
      if (!this.resourceData._entityName === 'de.ul.fob.domain.Person') { return false }
      if (!this.resourceData.orcid) { return false }

      return true
    },
    decorate () {
      return !this.isPublic && this.resourceData._entityName === 'de.ul.fob.domain.AbstractPerson'
    },
    decorationStyle () {
      return {
        '--decorator': `"${this.$gettext('extern')}"`
      }
    }
  }
}
</script>

<style scoped>
  .entity-decoration::before {
    content: var(--decorator);
    background: lightgray;
    color: black;
    border-radius: 5px;
    padding: 2px 4px;
    font-size: 0.7em;
  }
</style>


// WEBPACK FOOTER //
// src/components/EntityDecorator.vue